import { render, staticRenderFns } from "./UsageLimitDetails.vue?vue&type=template&id=a164cb4a&scoped=true&"
import script from "./UsageLimitDetails.vue?vue&type=script&lang=js&"
export * from "./UsageLimitDetails.vue?vue&type=script&lang=js&"
import style0 from "./UsageLimitDetails.vue?vue&type=style&index=0&id=a164cb4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a164cb4a",
  null
  
)

export default component.exports